module.exports = __webpack_public_path__ + "static/media/104oppositeBalls.50c3dfe8.gif";